import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import ArrowDown from 'utils/images/arrow-down.svg';
import PriceWithSymbol from '../../../../../../../utils/currency/PriceWithSymbol';
import { OPTION_GROUPS_MODALS } from '../../../constants';
import { displayChoiceLimit, displayPriceSubUnit } from '../../../utils';
import EditButton from '../../shared/EditButton';
import Required from '../../shared/Required';
import SelectButton from '../../shared/SelectButton';

const SectionContainer = styled.div`
  border-radius: 11px;
`;

const Panel = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 900px) {
    margin-left: 59px;
  }
`;

const LimitWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
  padding-left: 100px; //find an alternative solution for it !!

  @media (max-width: 900px) {
    margin-top: 16px;
  }
`;

const LimitHeader = styled.h1`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  text-align: right;
  letter-spacing: -0.2px;
  margin: 0;
  color: #000000;
  position: absolute;
  right: 22%;
  @media (max-width: 900px) {
    position: initial;
  }
`;
const ChoiceAndLimitWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
`;

const EditWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const HeaderWrapper = styled.div`
  display: 'flex';
  justify-content: 'center';
  flex-direction: 'row';
`;

const ExpanderArrow = styled.div`
  width: 12px;
  height: 7px;
  line-height: 12px;
  transform: rotate(270deg);
  cursor: pointer;

  ${props =>
    props.expanded &&
    css`
      transform: rotate(0deg);
      cursor: pointer;
      margin-top: -9px;
      margin-left: 0px;
    `}

  ${props =>
    props.hide &&
    css`
      visibility: hidden;
    `}
`;
const OptionGroupHeader = styled.p`
  display: flex;
  justify-content: center;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 16px;
  letter-spacing: -0.2px;
  color: #000000;
  margin-left: 15px;
  margin-top: 18px;
  cursor: pointer;
  ${props =>
    props.expanded &&
    css`
      font-weight: 600;
    `};
`;

const SelectedProductWrapper = styled.div`
  max-width: 644px;
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: border-box;
  border: 1px solid #dedede;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 18px 20px 20px 20px;
  margin-bottom: 20px;
`;
const SelectedProductContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-left: 52px;
`;

const OptionGroupWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;

  ${props =>
    props.expanded &&
    css`
      margin-top: 4px;
    `}
`;

const OptionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 0 22% 12px 58px; //figma 221px
  font-size: 13px;

  @media (max-width: 900px) {
    padding: 0px;
  }
`;

const ChoiceName = styled.h1`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #000000;
  @media (max-width: 900px) {
    margin-bottom: 2px;
  }
`;
const PriceContainer = styled.div`
  padding-right: 25px;

  @media (max-width: 900px) {
    margin-right: 10px;
    padding-right: 0;
  }
`;

const ChoiceLimitContainer = styled.div`
  display: flex;
  margin-left: 15px;
  //width: 57px;
  text-align: right;

  @media (max-width: 900px) {
    width: 70px;
    margin-right: 10px;
  }
`;

const ProductWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;
const ProductName = styled.p`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #000000;
  cursor: pointer;
  margin-bottom: 0px;
  margin-top: 6px;
`;

const ShowOptionContainer = styled.div`
  box-sizing: border-box;
  border-radius: 5px;
  ${props =>
    props.expanded &&
    css`
      height: 100%;
    `};
`;

const SelectedOptionsHeader = styled.p`
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.2px;
  color: #000000;
  margin-top: 0px;
  margin-bottom: 4px;
`;

const Limit = styled.p`
  margin: 0;
`;
const Border = styled.div`
  height: 1px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid #eeeeee;
  margin-top: 10px;
`;

const OptionGroupSelectedModal = props => {
  const {
    setSelectedDialog,
    setGroupToEdit,
    group,
    menus,
    isManageMode,
    setSelectedOptionGroup,
    selectedOptionGroup,
  } = props;
  const [showOptions, setShowOptions] = useState(false);
  const [menuSelector, setMenuSelector] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [isExpanded, setIsExpanded] = useState({});

  const toggleMenuSelector = () => {
    setMenuSelector(!menuSelector);
  };

  const handleShowOptions = () => {
    setShowOptions(!showOptions);
  };

  const handleEditOption = () => {
    setSelectedDialog(OPTION_GROUPS_MODALS.EDIT);
    setGroupToEdit(group);
  };

  return (
    <SectionContainer>
      <OptionWrapper>
        <Panel>
          <OptionGroupWrapper
            expanded={showOptions}
            onClick={handleShowOptions}
          >
            <ExpanderArrow expanded={showOptions}>
              <img alt="expand arrow" src={ArrowDown} />
            </ExpanderArrow>
            <HeaderWrapper>
              <OptionGroupHeader expanded={showOptions}>
                {group.name} {group.required && <Required>Required</Required>}
              </OptionGroupHeader>
            </HeaderWrapper>
          </OptionGroupWrapper>

          {showOptions && (
            <LimitWrapper>
              <LimitHeader>
                Limit: {displayChoiceLimit(group.choice_limit)}
              </LimitHeader>
            </LimitWrapper>
          )}
          <EditWrapper>
            <ButtonWrapper>
              {!isManageMode && (
                <SelectButton
                  selected={selectedOptionGroup[group.id]}
                  onSelect={() => {
                    const selectStatus = {
                      ...selectedOptionGroup,
                      [group.id]: !selectedOptionGroup[group.id],
                    };
                    setSelectedOptionGroup(selectStatus);
                  }}
                  key={`p-${group.id}`}
                  value={group.id}
                  id={`group-check-${group.id}`}
                >
                  Select
                </SelectButton>
              )}

              <EditButton onClick={handleEditOption} />
            </ButtonWrapper>
          </EditWrapper>
        </Panel>

        {showOptions &&
          (group.children || []).map(g => {
            return (
              <OptionsContainer>
                <Wrapper>
                  <ChoiceName>{g.name}</ChoiceName>
                </Wrapper>
                <ChoiceAndLimitWrapper>
                  <PriceContainer>
                    + <PriceWithSymbol price={displayPriceSubUnit(g.price)} />
                  </PriceContainer>
                  <ChoiceLimitContainer>
                    <Limit>{displayChoiceLimit(g.choice_limit)}</Limit>
                  </ChoiceLimitContainer>
                </ChoiceAndLimitWrapper>
              </OptionsContainer>
            );
          })}
        {showOptions && (
          <ShowOptionContainer
            expanded={!menuSelector}
            onClick={toggleMenuSelector}
          >
            <SelectedProductContainer>
              {Boolean(group.productIds.length) && (
                <SelectedProductWrapper>
                  <React.Fragment>
                    <SelectedOptionsHeader>
                      Group applied to:
                    </SelectedOptionsHeader>
                    {(menus || []).map(menu => {
                      const allProductsUnderThisMenu = (menu.children || [])
                        .map(c => (c.children || []).map(p => p.id))
                        .flat();
                      const doesMenuContainAnySelectedProducts =
                        allProductsUnderThisMenu.some(r =>
                          group.productIds.includes(r)
                        );
                      if (!doesMenuContainAnySelectedProducts) {
                        return null;
                      }

                      return (
                        <React.Fragment key={menu.id}>
                          {isExpanded &&
                            (menu.children || []).map(category => {
                              const allProductsUnderThisMenu = (
                                category.children || []
                              )
                                .map(p => p.id)
                                .flat();
                              const doesMenuContainAnySelectedProducts =
                                allProductsUnderThisMenu.some(r =>
                                  group.productIds.includes(r)
                                );
                              if (!doesMenuContainAnySelectedProducts) {
                                return null;
                              }

                              const ogs = (category.children || []).filter(p =>
                                group.productIds.includes(p.id)
                              );

                              return (
                                <React.Fragment>
                                  {isExpanded &&
                                    ogs.map(product => {
                                      return (
                                        <ProductWrapper>
                                          <ProductName>
                                            {product.name}
                                          </ProductName>
                                        </ProductWrapper>
                                      );
                                    })}
                                </React.Fragment>
                              );
                            })}
                        </React.Fragment>
                      );
                    })}
                  </React.Fragment>
                </SelectedProductWrapper>
              )}
            </SelectedProductContainer>
          </ShowOptionContainer>
        )}
      </OptionWrapper>
      <Border />
    </SectionContainer>
  );
};
export default OptionGroupSelectedModal;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/GlobalOptions/components/option-group-selected-modal.jsx